module.exports = __webpack_public_path__ + "img/eta-beta.46734a07.png";